module.exports = __webpack_public_path__ + "img/BR.d0203ca0.png";